import React from 'react';
import { testDataManagementView as TestDataManagementView } from './testDataManagementView';
import { fetch } from '../../modules/httpServices';
import APP from '../../modules/index';
import axios from 'axios';
import { cloneDeep } from 'lodash';
import * as XLSX from "xlsx";
import mammoth from "mammoth";

class TestDataManagementComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      requirementVal: '',
      businessRules: '',
      businessRulesCopy: '',
      totalVal: 0,
      dataLength: 0,
      totalValCopy: 0,
      uploadedData: '',
      businessVal: {},
      showRequirement: true,
      isLoading: false,
      isLoadingButton: false,
      countGenerate: false,
      countSave: false,
      requirementRadio: 'jira',
      createChatID: '',
      openErrorModal: false,
      sampleNoData: false,
      showFinalData: false,
      sampleYesData: false,
      jiraBooleanCheck: false,
      showDoc: true,
      showDocError: true,
      jiraVal: '',
      sampleGeneratedData: '',
      finalGeneratedData: '',
      documentVal: '',
      dbType: '',
      openModal: false,
      isSaveCheck: true,
      selectedProvider: '',
      selectedModel: "",
      llmModels: {},
      // openNewModal: false,
      dbOption: [
        { id: 'mysql', displayLabel: 'Mysql', value: 'mysql' },
        { id: 'sql', displayLabel: 'Sql', value: 'sql' },
        { id: 'mongodb', displayLabel: 'Mongodb', value: 'mongodb' },
        { id: 'couchbase', displayLabel: 'Couchbase', value: 'couchbase' },
        { id: 'postgres', displayLabel: 'Postgres', value: 'postgres' },
        { id: 'oracle', displayLabel: 'Oracle', value: 'oracle' }
      ],
      industryType: '',
      industryOption: [
        { id: 'banking', displayLabel: 'Banking', value: 'banking' },
        { id: 'insurance', displayLabel: 'Insurance', value: 'insurance' },
        { id: 'media', displayLabel: 'Media & Entertainment', value: 'media' },
        { id: 'retail', displayLabel: 'Retail', value: 'Retail' },
        { id: 'healthCare', displayLabel: 'HealthCare & Lifescience', value: 'healthCare' },
        { id: 'travel', displayLabel: 'Travel & Logistics', value: 'travel' },
      ],
      regionType: '',
      regionOption: [
        { id: 'india', displayLabel: 'India', value: 'india' },
        { id: 'us', displayLabel: 'US', value: 'us' },
        { id: 'uk', displayLabel: 'UK', value: 'uk' },
        { id: 'europe', displayLabel: 'Europe', value: 'europe' },
        { id: 'uae', displayLabel: 'UAE', value: 'uae' }
      ],
      showBusiness: false,
      errorMessage: '',
      applicationData: [],
      appOptions: [],
      chatGptData: [],
      apiTitle: ''
    };
  }

  componentDidMount() { 
    this.fetchLlmConfig();
  }

  handleChangellm = (e) => {
    const [provider, model] = e.target.value.split("|");
    this.setState({
      selectedProvider: provider,
      selectedModel: model
    });
  };

  fetchLlmConfig = () => {
    const token = localStorage.getItem('AceToken');
      const orgId = localStorage.getItem('OrgId');
      const aceBackendUrl = localStorage.getItem('AceBackendUrl');
      // this.setState({ isLoadingButton: true });
      fetch.post({
        url: APP.Constants.SERVICE_URLS.LLM_CONFIG,
        requestBody: { token, orgId, aceBackendUrl },
        callbackHandler: (res) => {
          const { status, payload } = res;
          if (APP.Constants.SUCCESS === status) {
            const { defaultLlmProvider, llmModels } = payload;
            const providerModels = llmModels?.[defaultLlmProvider] || {};
            const defaultModel = Object.keys(providerModels)[0] || '';

        this.setState({
          selectedProvider: defaultLlmProvider,
          selectedModel: defaultModel,
          llmModels
        });
          } else {
            this.setState({ errorMessage: 'Failed to fetch LLM configuration', openErrorModal: true});
          }
        }
      });
  }
  onChange = ({ eve, id, value }) => {
    const _state = cloneDeep(this.state);
    if (id === 'totalVal') {
      let val = parseInt(value);
      val > 5000 ? _state[id] = 5000 : _state[id] = value
    } else {
      _state[id] = value
    }
    id === 'dbType' && _state[id] !== ''
      ? (_state.jiraBooleanCheck = true)
      : (_state.jiraBooleanCheck = false);
    this.setState(_state);
  };

  backtostep1 = () => {
    if (
      document.getElementById('secondli').classList.value !== '' ||
      document.getElementById('thirdli').classList.value !== ''
    ) {
      document.getElementById('secondli').classList.remove('is-active');
      document.getElementById('thirdli').classList.remove('is-active');
      document.getElementById('firstli').classList.add('is-active');
      this.setState({
        showBusiness: false,
        showRequirement: true,
        showStep1Data: true,
        showFinalData: false,
        countSave: false,
        countGenerate: false
      });
    }
  };
  backtostep2 = () => {
    if (document.getElementById('thirdli').classList.value !== '') {
      document.getElementById('thirdli').classList.remove('is-active');
      document.getElementById('secondli').classList.add('is-active');
      this.setState({
        showBusiness: true,
        sampleNoData: false,
        sampleYesData: false,
        showFinalData: false,
        countSave: false,
        countGenerate: false
      });
    }
  };

  onCancel = () => {
    this.setState({ requirementVal: '' });
  };
  closePopup = () => {
    this.setState({ openModal: false });
  };
  openPopup = () => {
    this.setState({ openModal: true, jiraVal: '', showDocError: true });
  };
  // openNewPopup = () => {
  //   this.setState({ openNewModal: true });
  // };
  redirectToAnotherPage = () => {
    this.props.goToPage(APP.Constants.ROUTES.DESIGN_HOME);
  };

  onChangeRadioButton = (val, eve, id) => {
    const _state = { ...this.state };
    _state.requirementRadio = val;
    _state.showDoc = !_state.showDoc;
    this.setState(_state);
  };


 onUpload = async (eve) => {
   try {
     const file = eve.target.files[0];
     if (!file) return;

     const fileName = file.name.toLowerCase();

     if (fileName.endsWith(".docx")) {
       const arrayBuffer = await file.arrayBuffer();

       const result = await mammoth.extractRawText({
         arrayBuffer
       });

       this.setState({
         uploadedData: result.value,
         showDocError: false
       });
     }
     else if (
       fileName.endsWith(".xls") ||
       fileName.endsWith(".xlsx")
     ) {
       const arrayBuffer = await file.arrayBuffer();

       const workbook = XLSX.read(arrayBuffer, {
         type: "array"
       });

       let text = "";

       workbook.SheetNames.forEach(sheetName => {
         const worksheet = workbook.Sheets[sheetName];

         text += `Sheet: ${sheetName}\n`;

         text += XLSX.utils.sheet_to_csv(worksheet);

         text += "\n\n";
       });

       this.setState({
         uploadedData: text,
         showDocError: false
       });
     }
     else {
       alert("Please upload .docx, .xls or .xlsx");
     }
   } catch (err) {
     console.error(err);
   }
 };

  onDone = (val) => {
    const { dbType, requirementVal, businessRules, businessRulesCopy, industryType, regionType, selectedModel, selectedProvider } =
      this.state;
    this.setState({ isLoading: true });
    const businessVal = val === 'generate' ? businessRules : businessRulesCopy;
    fetch.post({
      url: APP.Constants.SERVICE_URLS.CHECK_API_DATA,
      requestBody: { prompt: requirementVal },
      callbackHandler: (res) => {
        const { status, payload } = res;
        if (APP.Constants.SUCCESS === status) {
          if (payload === 'garbage') {
            this.setState({
              openErrorModal: true,
              isLoading: false,
              errorMessage: 'junkerror'
            });
          } else {
            fetch.post({
              url: APP.Constants.SERVICE_URLS.PYTHON_CREATE,
              requestBody: {
                requirement: requirementVal,
                dbType,
                industryType,
                regionType,
                dataCount: 5,
                provider: selectedProvider,
                model: selectedModel,
                businessRules: businessVal
              },
              callbackHandler: (res) => {
                const { status, payload } = res;
                if (APP.Constants.SUCCESS === status) {
                  this.setState({ createChatID: payload });
                  if (val === 'generate') {
                    document.getElementById('firstli').classList.remove('is-active');
                    document.getElementById('secondli').classList.add('is-active');
                    fetch.post({
                      url: APP.Constants.SERVICE_URLS.PYTHON_GENERATE,
                      requestBody: {
                        chatId: `${payload}`,
                        dataCount: 5,
                        provider: selectedProvider, 
                        model: selectedModel
                      },
                      callbackHandler: (res) => {
                        const { status, payload } = res;
                        if (APP.Constants.SUCCESS === status) {
                          this.setState({
                            sampleGeneratedData: payload,
                            sampleNoData: false,
                            sampleYesData: false,
                            showBusiness: true,
                            showRequirement: false,
                            isLoading: false
                          });
                        } else {
                          this.setState({
                            openErrorModal: true,
                            isLoading: false,
                            errorMessage: status
                          });
                        }
                      }
                    })
                  } else {
                    fetch.post({
                      url: APP.Constants.SERVICE_URLS.PYTHON_GENERATE,
                      requestBody: {
                        chatId: `${payload}`,
                        dataCount: 5,
                        provider: selectedProvider,
                        model: selectedModel
                      },
                      callbackHandler: (res) => {
                        const { status, payload } = res;
                        if (APP.Constants.SUCCESS === status) {
                          this.setState({
                            sampleGeneratedData: payload,
                            sampleNoData: false,
                            sampleYesData: false,
                            isLoading: false
                          });
                        } else {
                          this.setState({
                            openErrorModal: true,
                            isLoading: false,
                            errorMessage: status
                          });
                        }
                      }
                    })

                  }
                } else {
                  if (val === 'regenerate') {
                    document.getElementById('firstli').classList.remove('is-active');
                    document.getElementById('secondli').classList.add('is-active');
                  }
                  this.setState({
                    openErrorModal: true,
                    isLoading: false,
                    errorMessage: status
                  });
                }
              }
            });
          }
        }
      }
    });
  };

  sampleAllData = (val) => {
    const { businessRulesCopy, businessRules } = this.state;
    if (val === 'yes') {
      this.setState({ sampleNoData: false, sampleYesData: true });
    } else {
      this.setState({
        sampleNoData: true,
        sampleYesData: false,
        businessRulesCopy:
          businessRulesCopy === '' ? businessRules : businessRulesCopy
      });
    }
  };

  closeErrorPopup = () => {
    this.setState({
      // sampleGeneratedData: '',
      // finalGeneratedData: '',
      openErrorModal: false,
      errorMessage: ''
    });
  };

  generateAllData = () => {
    const {
      dbType,
      requirementVal,
      businessRules,
      businessRulesCopy,
      regionType,
      industryType,
      createChatID,
      selectedProvider,
      selectedModel,
      totalVal
    } = this.state;
    this.setState({ isLoading: true });
    // fetch.post({
    //   url: APP.Constants.SERVICE_URLS.PYTHON_ADD,
    //   requestBody: {
    //     requirement: requirementVal,
    //     dbType,
    //     regionType,
    //     industryType,
    //     dataCount: totalVal,
    //     businessRules:
    //       businessRulesCopy === '' ? businessRules : businessRulesCopy
    //   },
    //   callbackHandler: (res) => {
    // const { status, payload } = res;
    // if (APP.Constants.SUCCESS === status) {
    fetch.post({
      url: APP.Constants.SERVICE_URLS.PYTHON_GENERATE,
      requestBody: {
        chatId: `${createChatID}`,
        dataCount: totalVal,
        provider: selectedProvider,
        model: selectedModel,
      },
      callbackHandler: (res) => {
        const { status, payload } = res;
        if (APP.Constants.SUCCESS === status) {
          document.getElementById('secondli').classList.remove('is-active');
          document.getElementById('thirdli').classList.add('is-active');
          this.setState({
            finalGeneratedData: payload,
            dataLength: payload?.length,
            showBusiness: false,
            showFinalData: true,
            isLoading: false
          });
        } else {
          this.setState({
            openErrorModal: true,
            isLoading: false,
            errorMessage: status
          });
        }
      }
    })
    // } else {
    //   this.setState({
    //     openErrorModal: true,
    //     isLoading: false,
    //     errorMessage: status
    //   });
    // }
    //   }
    // });
  };

  onSaveData = () => {

  }

  onAddTable = () => {

  }

  submitRequirement = () => {
    const _state = cloneDeep(this.state);
    // if (_state.showDoc) {
    //   this.setState({ isLoadingButton: true });
    //   fetch.get({
    //     url: APP.Constants.SERVICE_URLS.JIRA_INTEGRATION + this.state.jiraVal,
    //     callbackHandler: (res) => {
    //       const { status, payload } = res;
    //       if (APP.Constants.SUCCESS === status) {
    //         if (payload.errorMessage === null) {
    //           this.setState({
    //             requirementVal: `${
    //               payload.summary === null ? '' : payload.summary
    //             }
    //             ${payload.description === null ? '' : payload.description}`,
    //             openModal: false,
    //             isLoadingButton: false
    //           });
    //         } else {
    //           alert(payload.errorMessage);
    //           this.setState({
    //             requirementVal: '',
    //             openModal: false,
    //             isLoadingButton: false
    //           });
    //         }
    //       } else {
    //         this.setState({ requirementVal: '', isLoadingButton: false });
    //       }
    //     }
    //   });
    // } else {
    this.setState({
      requirementVal: _state.uploadedData,
      openModal: false,
      isLoadingButton: false
    });
    // }
  };
  onDownloadSave = (eve, name) => {
    const _state = cloneDeep(this.state);
    const userMail = localStorage.getItem("email");
    const orgId = localStorage.getItem('OrgId');
    const projectId = localStorage.getItem('ProjectId');
    if (name === 'download') {
      fetch.post({
        url: APP.Constants.SERVICE_URLS.GPT_SAVE_API,
        requestBody: {
          testGenData: _state.finalGeneratedData,
          testGenSchema: _state.requirementVal,
          count: _state.totalVal,
          dataValidation:
            _state.businessRulesCopy === ''
              ? _state.businessRules
              : _state.businessRulesCopy,
          jiraId: _state.jiraVal,
          dbType: _state.dbType,
          actionType: 'TestData',
          userName: userMail,
          orgId,
          projectId
        },
        callbackHandler: (res) => {
          const { status } = res;
          if (APP.Constants.SUCCESS === status) {
            const date = new Date();
            const csvData =
              'data:application/csv;charset=utf-8,' +
              encodeURIComponent(_state.finalGeneratedData);
            let link = document.createElement('a');
            link.setAttribute('href', csvData);
            link.setAttribute(
              'download',
              `${_state.dbType}_${date.getDate() +
              '-' +
              (date.getMonth() + 1) +
              '-' +
              date.getFullYear() +
              ' ' +
              date.getHours() +
              ':' +
              date.getMinutes() +
              ':' +
              date.getSeconds()
              }.csv`
            );
            document.body.appendChild(link);
            link.click();
            this.setState({ countSave: true });
          } else {
            this.setState({
              openErrorModal: true,
              isLoading: false,
              errorMessage: status
            });
          }
        }
      });
    } else {
      this.setState({ isLoadingButton: true });
      fetch.post({
        url: APP.Constants.SERVICE_URLS.SAVE_DATA_API,
        requestBody: {
          requirement: _state.finalGeneratedData,
          dbType: _state.dbType,
          userName: userMail
        },
        callbackHandler: (res) => {
          const { status, payload } = res;
          if (APP.Constants.SUCCESS === status) {
            const dbName = _state.dbType;
            const date = new Date();
            const csvData =
              'data:data/text;charset=utf-8,' + encodeURIComponent(payload);
            let link = document.createElement('a');
            link.setAttribute('href', csvData);
            link.setAttribute(
              'download',
              `${dbName}_${date.getDate() +
              '-' +
              (date.getMonth() + 1) +
              '-' +
              date.getFullYear() +
              ' ' +
              date.getHours() +
              ':' +
              date.getMinutes() +
              ':' +
              date.getSeconds()
              }.txt`
            );
            document.body.appendChild(link);
            link.click();
            // this.openNewPopup();
            this.setState({
              isLoadingButton: false,
              countGenerate: true
            });
          } else {
            this.setState({
              openErrorModal: true,
              isLoadingButton: false,
              errorMessage: status
            });
          }
        }
      });
    }
  };

  render() {
    return (
      <TestDataManagementView
        {...{
          ...this.state,
          onChange: this.onChange,
          onCancel: this.onCancel,
          onDone: this.onDone,
          onDownloadSave: this.onDownloadSave,
          closePopup: this.closePopup,
          onUpload: this.onUpload,
          closeErrorPopup: this.closeErrorPopup,
          openPopup: this.openPopup,
          sampleAllData: this.sampleAllData,
          onSaveData: this.onSaveData,
          onAddTable: this.onAddTable,
          submitRequirement: this.submitRequirement,
          onChangeRadioButton: this.onChangeRadioButton,
          redirectToAnotherPage: this.redirectToAnotherPage,
          generateAllData: this.generateAllData,
          backtostep1: this.backtostep1,
          backtostep2: this.backtostep2,
          handleChangellm: this.handleChangellm
        }}
      />
    );
  }
}

export default TestDataManagementComponent;
